import { Route as ExpiryListRoute } from "@/routes/(inventory)/branch/_layout/reports/expiry-list/index";
import { useQuery } from "@tanstack/react-query";
import { getExpiryList } from "../-data/api";
import { GetInventoryResponse } from "@/gen/inventory/get_inventory_pb";

interface ReportQueryResult {
  items: any[];
  totalCount: number;
  page: number;
  pageSize: number;
}

export const useExpiryListData = () => {
  const searchParams = ExpiryListRoute.useSearch();
  
  const page = searchParams.page || 1;
  const pageSize = searchParams.pageSize || 10;
  
  return useQuery<ReportQueryResult>({
    queryKey: ["expiry-list", searchParams],
    queryFn: async () => {
      const response = await getExpiryList(page, pageSize);
      
      return {
        items: response.items,
        totalCount: response.totalCount,
        page,
        pageSize,
      };
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};